export default __webpack_public_path__ + "static/media/logout.e31f3944.svg";